import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import assetApi from '../../api/asset';
import shopStockApi from '../../api/shopStock';
import retailerAuthxApi from '../../api/retailerAuthx';
import retailerApi from '../../api/retailer';
import shopDevcApi from '../../api/shopDevc';
import merchtComnApi from '../../api/merchtComn';
import bizAreaApi from '../../api/bizArea';

// 加载财务类别选择
export function loadAssetKindList(callback) {
    let postData = {};
    postData.level = 1;
    assetApi.getAssetKindList(postData, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let assetKindList = result.data;
            if(!Utils.isNoB(assetKindList) && assetKindList.length > 0) {
                dataList.push({'value': null, 'label': '-全部-'});
                assetKindList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        }
    });
}

// 加载财务类别
export function getAssetKindList(callback) {
    assetApi.getAssetKindList({}, function (result) {
        if(result.type == 'info') {
            let dataList = result.data || [];
            //
            callback(dataList);
        } else {
            callback([]);
        }
    });
}

export function getAssetKindListAll(callback) {
    assetApi.getAssetKindListAll({}, function (result) {
        if(result.type == 'info') {
            let dataList = result.data || [];
            //
            callback(dataList);
        } else {
            callback([]);
        }
    });
}

// 加载仓库选择
export function loadShopWarehouseList(comId, callback) {
    let postData = {};
    postData.filterItems = {retailerShopId: comId};
    //
    shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let warehouseList = result.data;
            if(!Utils.isNoB(warehouseList) && warehouseList.length > 0) {
                dataList.push({'value': null, 'label': '-全部-'});
                warehouseList.forEach(function (item) {
                    let dataItem = {
                        value: item.id,
                        label: item.name
                    };
                    dataList.push(dataItem);
                });
            }
            callback(dataList);
        }
    });
}

// 加载分类分组
export function loadRetailerDevcGroupList(callback) {
    retailerAuthxApi.getDevcGroupListByContext({}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let devcGroupList = result.data;
            if(!Utils.isNoB(devcGroupList) && devcGroupList.length > 0) {
                // dataList.push({"value": null, "label": "-全部-"});
                devcGroupList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.fullName
                    });
                });
            }
            callback(dataList);
        }
    });
}

// 加载级联分类分组（两级）
export function loadRetailerDevcGroupCascList(callback) {
    retailerAuthxApi.getDevcGroupCascListByContext({}, function (result) {
        if(result.type == 'info') {
            let dataList = result.data;
            //
            callback(dataList);
        }
    });
}

// 加载门店标签选择
export function loadRetailerShopTagList(callback, multiSelect = false) {
    retailerApi.getRetailerShopTagListByContext({}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let retailerShopTagList = result.data;
            if(multiSelect == false){
                dataList.push({'value': null, 'label': '-全部-'});
            }
            if(!Utils.isNoB(retailerShopTagList) && retailerShopTagList.length > 0) {
                retailerShopTagList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        }
    })
}

// 加载自有分类
export function loadDevcCatListList(callback) {
    shopDevcApi.getDevcCatList({level: 3}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            //
            let devcCatList = result.data;
            if(!Utils.isNoB(devcCatList) && devcCatList.length > 0) {
                dataList.push({'value': null, 'label': '-全部-'});
                devcCatList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        }
    })
}

export function loadIoFlagList(callback) {
    let ioFlagList = getEnumList('ioFlag');
    let dataList = [];
    if(ioFlagList != null && ioFlagList.length > 0) {
        dataList.push({'value': null, 'label': '-全部-'});
        //
        ioFlagList.forEach(function (item) {
            let queryItem = {};
            queryItem.value = item.value;
            queryItem.label = item.text;
            dataList.push(queryItem);
        });
    }
    callback(dataList);
}

export function loadDevcVoucherTypeList(callback) {
    let devcVoucherTypeList = getEnumList('devcVoucherType');
    let dataList = [];
    if(devcVoucherTypeList != null && devcVoucherTypeList.length > 0) {
        dataList.push({'value': null, 'label': '-全部-'});
        //
        devcVoucherTypeList.forEach(function (item) {
            let queryItem = {};
            queryItem.value = item.value;
            queryItem.label = item.text;
            dataList.push(queryItem);
        });
    }
    callback(dataList);
}

export function loadStuffVoucherTypeList(callback) {
    let stuffIoVoucherTypeList = getEnumList('stuffIoVoucherType');
    let dataList = [];
    if(stuffIoVoucherTypeList != null && stuffIoVoucherTypeList.length > 0) {
        dataList.push({'value': null, 'label': '-全部-'});
        //
        stuffIoVoucherTypeList.forEach(function (item) {
            let queryItem = {};
            if(item.value != 5) {   // 归还 - 耗材无归还，页面取消展示
                queryItem.value = item.value;
                queryItem.label = item.text;
                dataList.push(queryItem);
            }
        });
    }
    callback(dataList);
}

// 加载入账方式
export function loadAcctEnterWayList(callback) {
    let acctEnterWayList = getEnumList('acctEnterWay');
    let dataList = [];
    if(acctEnterWayList != null && acctEnterWayList.length > 0) {
        //
        acctEnterWayList.forEach(function (item) {
            let queryItem = {};
            queryItem.value = item.value;
            queryItem.label = item.text;
            dataList.push(queryItem);
        });
    }
    callback(dataList);
}

// 资产折旧算法
export function loadAssetDeprMethodList(assetType, callback) {
    //
    let assetDeprMethodList = getEnumList('assetDeprMethod') || [];
    let dataList = [];
    //
    let commonDevcVal = getEnumInfoWith('assetType', 'name', 'CommonDevc').value;// 普通资产
    let durableDevcVal = getEnumInfoWith('assetType', 'name', 'DurableDevc').value;// 耐用资产
    let lowCostVal = getEnumInfoWith('assetType', 'name', 'LowCost').value;// 耐用资产
    // dataList.push({"value": null, "label": "-全部-"});
    assetDeprMethodList.forEach(function (item) {
        if(commonDevcVal == assetType || durableDevcVal == assetType) {
            // if(item.name != 'ONCE') {
            // }
            dataList.push({
                value: item.name,
                label: item.text
            });
        } else if(lowCostVal == assetType) {
            if(item.name == 'NONE' || item.name == 'ONCE') {
                if(item.name == 'NONE') {
                    dataList.push({
                        value: item.name,
                        label: '不摊销'
                    });
                } else {
                    dataList.push({
                        value: item.name,
                        label: '一次性摊销'
                    });
                }
            }
        } else {
            dataList.push({
                value: item.name,
                label: item.text
            });
        }
    });
    callback(dataList);
}

export function loadAllotAcntMethodList(callback) {
    let allotAcntMethodList = getEnumList('allotAcntMethod') || [];
    let dataList = [];
    allotAcntMethodList.forEach(function (item) {
        dataList.push({
            value: item.name,
            label: item.text
        });
    });
    callback(dataList);
}

// 资产状态更新导入
import { fileUploadGroupShowDlg } from '../comn/dialog'
import { openAssetBizStateImpCheckDlg } from '../retailer/selectDlg'

export function assetBizStateImportModel(params, callbackFunc) {
    let bizUnitId = params['bizUnitId'] || null;
    let includeSubComs = params['includeSubComs'] || false;
    //
    let tplUsage = 'devc.asset.biz.state.impl';
    let uploadParams = {
        title: '资产更新导入',
        fileGroup: 'asset.bizState.import',
        multipleFile: false,
        usage: tplUsage,
        lableText: '更新导入',
    };
    let downlaodUrl = '/api/shop/device/asset/bizState/imp/model/file/download?bizUnitId=' + bizUnitId;
    // let downlaodUrl = Utils.makeUrl("/api/shop/device/asset/bizState/imp/model/file/download", params);
    fileUploadGroupShowDlg(uploadParams, downlaodUrl, function (result, theDlg) {
        theDlg.close();
        if(result.type === 'info') {
            let files = result.data.files || [];
            let fileObj = files[0];
            let deviceImpInfoList = fileObj.extra.deviceImpInfoList || [];
            if(Utils.isNoB(deviceImpInfoList) || deviceImpInfoList.length <= 0) {
                MsgBox.warning('没有更新的资产数据，请确认');
                return;
            }
            let errorMsgList = fileObj.extra.errorMsgList;
            if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                MsgBox.warning(errorMsgList.join('<br/>'));
                return;
            }
            let fileObj2 = {
                extra: {
                    includeSubComs: includeSubComs,
                    retailerBizUnitId: bizUnitId,
                    originalFileName: fileObj.extra.originalFileName,
                    deviceImpInfoList: deviceImpInfoList,
                    dumyBrandNames: [],
                    tplUsage: tplUsage
                },
            };
            openAssetBizStateImpCheckDlg(fileObj2, function (success) {
                callbackFunc();
            });
        } else {
            MsgBox.warning(result.message);
        }
    });
}

// 加载管理区域（大区、小区）
export function loadRetailerMgmtAreaList(bigMgmtArea, callback) {
    let level = Utils.isTrue(bigMgmtArea) ? 1 : 2;
    merchtComnApi.getMgmtAreaTreeList({filterItems: {level: level, treeFlag: false, disabled: false}}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            let mgmtAreaList = result.data;
            if(!Utils.isNoB(mgmtAreaList) && mgmtAreaList.length > 0) {
                mgmtAreaList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        } else if(result.type == 'error') {
            MsgBox.error(result.message, result.errid);
        } else {
            MsgBox.warning(result.message);
        }
    })
}

// 加载管理区域（级联）
export function loadRetailerMgmtAreaTree(callback) {
    merchtComnApi.getMgmtAreaTreeList({filterItems: {treeFlag: true, disabled: false}}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            let mgmtAreaList = result.data;
            if(!Utils.isNoB(mgmtAreaList) && mgmtAreaList.length > 0) {
                mgmtAreaList.forEach(function (mgmtBig) {
                    let childrenList = [];
                    if(!Utils.isNoB(mgmtBig.mgmtAreaSons) && mgmtBig.mgmtAreaSons.length > 0){
                        mgmtBig.mgmtAreaSons.forEach(function (mgmtSml){
                            childrenList.push({
                                value: mgmtSml.id,
                                label: mgmtSml.name,
                                leaf: true
                            });
                        });
                    }
                    dataList.push({
                        value: mgmtBig.id,
                        label: mgmtBig.name,
                        children: childrenList
                    });
                });
            }
            callback(dataList);
        } else if(result.type == 'error') {
            MsgBox.error(result.message, result.errid);
        } else {
            MsgBox.warning(result.message);
        }
    })
}

export function loadgetRetailerBizAreaList(callback) {
    bizAreaApi.getRetailerBizAreaListForSelect({disabled: false}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            let bizAreaList = result.data;
            if(!Utils.isNoB(bizAreaList) && bizAreaList.length > 0) {
                bizAreaList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        } else if(result.type == 'error') {
            MsgBox.error(result.message, result.errid);
        } else {
            MsgBox.warning(result.message);
        }
    })
}

export function loadgetRetailerBizFormList(callback) {
    merchtComnApi.getRetailerBizFormList({disabled: false}, function (result) {
        if(result.type == 'info') {
            let dataList = [];
            let bizAreaList = result.data;
            if(!Utils.isNoB(bizAreaList) && bizAreaList.length > 0) {
                bizAreaList.forEach(function (item) {
                    dataList.push({
                        value: item.id,
                        label: item.name
                    });
                });
            }
            callback(dataList);
        } else if(result.type == 'error') {
            MsgBox.error(result.message, result.errid);
        } else {
            MsgBox.warning(result.message);
        }
    })
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/retailer/asset-comn.js
// module id = 15
// module chunks = 0